import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { EmployeeWorkExperienceSubmit, EmployeeWorkExperienceVerbose } from '../models/employee-work-experience.model';
import { catchError, map } from 'rxjs/operators';
import { api_routes } from '@app/consts';
import { EnvironmentService } from "@app/core/services/environment.service";


const headers = new HttpHeaders({
  'Content-Type':  'application/json',
});

@Injectable({
  providedIn: 'root'
})
export class EmployeeWorkExperienceService {

  constructor(private http: HttpClient, private envService: EnvironmentService) {}

  getWorkExperiences(employeeId: string, take?: number, skip?: number, sortString?: string): Observable<any> {
    let params = new HttpParams();
    skip ? params = params.append('skip', skip) : null;
    take ? params = params.append('take', take) : null;
    sortString ? params = params.append('Sort', sortString) : null;

    return this.http.get<any>(`${this.envService.env.apiUrl}${api_routes.TALENT}/${employeeId}/${api_routes.WORK_EXPERIENCES}`, {
      headers: headers,
      params: params
    })
    .pipe(
      catchError(err => throwError(err)),
      map(res => {
        let data = {
          data: res.data,
          total: res.total
        }

        return data;
      })
    );
  }

  deleteWorkExperience(employeeId: string, id: string): Observable<any> {
    return this.http.delete<any>(`${this.envService.env.apiUrl}${api_routes.TALENT}/${employeeId}/${api_routes.WORK_EXPERIENCES}/${id}`, {
      headers: headers
    });
  }

  getWorkExperience(employeeId: string, id: string): Observable<EmployeeWorkExperienceVerbose> {
    return this.http.get<any>(`${this.envService.env.apiUrl}${api_routes.TALENT}/${employeeId}/${api_routes.WORK_EXPERIENCES}/${id}`, {
      headers: headers
    });
  }

  updateWorkExperience(employeeId: string, employeeWorkExperience: EmployeeWorkExperienceSubmit): Observable<any> {
    return this.http.put<any>(`${this.envService.env.apiUrl}${api_routes.TALENT}/${employeeId}/${api_routes.WORK_EXPERIENCES}/${employeeWorkExperience.id}`, employeeWorkExperience, {
      headers: headers
    });
  }

  createWorkExperience(employeeId: string, employeeWorkExperience: EmployeeWorkExperienceSubmit): Observable<any> {
    return this.http.post<any>(`${this.envService.env.apiUrl}${api_routes.TALENT}/${employeeId}/${api_routes.WORK_EXPERIENCES}`, employeeWorkExperience, {
      headers: headers
    });
  }
}
